import React from "react";
import "./HeaderForms.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HeaderForms = (props) => {
    return (
        <div className="headerForm">
            <h1><div className="iconbox"><FontAwesomeIcon icon={props.icon}></FontAwesomeIcon></div>{props.text}</h1>
        </div>
    );
}

export default HeaderForms;